import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'btn-flat',
  templateUrl: './btn-flat.component.html',
  styleUrls: ['./btn-flat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BtnFlatComponent {
  @Input() disabled: boolean = false;
  @Input() withIcon: boolean = false;
  @Input() iconClass: string;
  @Input() styleClasses: string;
  @Input() buttonLabel: string;
  @Input() uppercase: boolean = true;

  @Output() applyAction = new EventEmitter();

  onSubmit() {
    if (!this.disabled) {
      this.applyAction.next(true);
    }
  }
}
